





























import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { TabField } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import TabsHeader from "@/components/TabsHeader";
import PromotedUserList from "./components/PromotedUserList";
import PromotedUsersTabs from "./components/PromotedUsersTabs";
import usersAllController from "./controllers/usersAllController";
import usersNewController from "./controllers/usersNewController";
import usersOnlineController from "./controllers/usersOnlineController";
import { PromotedUsersTab } from "./types";

export default defineComponent({
  name: "PagePromotedUsers",
  components: {
    PromotedUserList,
    BasePage,
    PageTitle,
    PromotedUsersTabs,
    TabsHeader,
    BaseIcon,
  },
  props: {
    promotedType: { type: String as () => PromotedUsersTab["value"], default: "all" },
  },
  setup(props) {
    const loading = ref(false);
    const { authUser } = useAuthUser();
    const controller = computed(() => {
      switch (props.promotedType) {
        case "online":
          return usersOnlineController;
        case "new":
          return usersNewController;
        case "all":
          return usersAllController;

        default:
          return null;
      }
    });

    const allowSearch = computed(() => {
      return config.featureSearchBar;
    });

    const tabs = computed<TabField[]>(() => {
      const list = [
        {
          name: "home",
          text: $t("Home"),
          to: { name: "home" },
        },
        {
          name: "discover",
          text: $t("Discover"),
          to: { name: "discover", params: { type: "all" } },
        },
      ];
      return (authUser.value && list) || list.filter(i => i.name !== "home");
    });

    return {
      allowSearch,
      controller,
      authUser,
      loading,
      tabs,
    };
  },
});
